import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=2cca6858&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&id=2cca6858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca6858",
  null
  
)

export default component.exports